import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 48B50BA6-7F60-49CC-A181-3E07607E9F4B
 * name swap-horizontal-hidden
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-horizontal-hidden.svg
 * tags
 * - Arrow 
 */
export const SwapHorizontalHiddenIcon = createSvgIcon(<><path d="M17 5L21 9L17 13V5M16 8H13V10H16V8M12 10V8H10V10H12M3 15L7 11V19L3 15M8 16H11V14H8V16M12 14V16H14V14H12Z" /></>, 'SwapHorizontalHiddenIcon');
export default SwapHorizontalHiddenIcon